import React, { useState } from "react";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { generatesummary } from '../../../../services/CommonService';
import SummaryContent from './SummaryContent';

const ContractSummaryModal = ({
  envelopeId,
  fileName,
  buttonClassName,
  buttonLabel,
  disabled,
  renderTrigger,
  container
}) => {
  const [summaryData, setSummaryData] = useState(null);
  const [isSummaryLoading, setIsSummaryLoading] = useState(false);
  const [showSummaryModal, setShowSummaryModal] = useState(false);

  const fetchSummary = async (currentFileName) => {
    if (!envelopeId) {
      toast.error("Document not loaded properly.");
      return;
    }
    setIsSummaryLoading(true);
    try {
      const payload = { envelope_id: Number(envelopeId), file_name: currentFileName };
      const response = await generatesummary(payload);

      if (response.data && response.data.summaries) {
        let fetchedData = response.data.summaries;
        // Parse Timeline JSON if needed
        if (fetchedData.contract_timelines && typeof fetchedData.contract_timelines === 'string') {
          try {
            const match = fetchedData.contract_timelines.match(/```json\n([\s\S]*?)\n```/);
            if (match && match[1]) fetchedData.contract_timelines = JSON.parse(match[1]);
          } catch (e) { console.warn("JSON parse error", e); }
        }
        setSummaryData(fetchedData);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to generate summary.");
    } finally {
      setIsSummaryLoading(false);
    }
  };

  const handleOpen = async (e) => {
    if (e) e.preventDefault();
    setShowSummaryModal(true);
    if (!summaryData) await fetchSummary(fileName);
  };

  const handleClose = () => {
    setShowSummaryModal(false);
  };

  return (
    <>
      {/* Trigger Button */}
      {renderTrigger ? (
        renderTrigger({ onClick: handleOpen, isLoading: isSummaryLoading, disabled: disabled || isSummaryLoading })
      ) : (
        <button
          type="button"
          className={buttonClassName || "btn btn-secondary me-2"}
          onClick={handleOpen}
          disabled={disabled || isSummaryLoading}
        >
          {isSummaryLoading ? "Loading..." : (buttonLabel || "Summary")}
        </button>
      )}

      {/* Bootstrap Modal */}
      <Modal 
        show={showSummaryModal} 
        onHide={handleClose}
        size="lg"
        centered
        backdrop="static"
        container={renderTrigger ? undefined : container}
      >
        <Modal.Header >
          <Modal.Title>Contract Summary</Modal.Title>
          <button
            type="button"
            className="btn-close"
            onClick={handleClose}
          ><i className="bi bi-x-circle"/></button>
        </Modal.Header>
        
        <Modal.Body className="p-0" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
          {isSummaryLoading ? (
            <div className="p-5 text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="mt-3 text-muted">Analyzing document...</div>
            </div>
          ) : summaryData ? (
            <SummaryContent 
              summaries={summaryData} 
              onClose={handleClose} 
            />
          ) : (
            <div className="p-5 text-center text-muted">
              No summary available.
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ContractSummaryModal;